export function formatDateTr(value?: string) {
  if (!value) return "—";
  const [year, month, day] = value.slice(0, 10).split("-");
  return year && month && day ? `${day}.${month}.${year}` : value;
}

export function isDateInRange(value?: string, from?: string, to?: string) {
  const date = String(value ?? "").slice(0, 10);
  if (!date) return false;
  if (from && date < from) return false;
  if (to && date > to) return false;
  return true;
}

export function matchesOptionalDateRange(value?: string, from?: string, to?: string) {
  if (!from && !to) return true;
  return isDateInRange(value, from, to);
}
